import { useMemo } from 'react';
import { ImmuzationType } from 'pages/enums';

export const useRequiredImmunizationDocument = ({
  requirementTypeId
}) => {
  return useMemo(() => {
    const notRequired = [ImmuzationType.Tdap, ImmuzationType.TdapNew];

    if (notRequired.includes(requirementTypeId)) {
      return false;
    }

    return true;
  }, [requirementTypeId]);
};

export default useRequiredImmunizationDocument;
